export default __webpack_public_path__ + "static/media/partner-02.ede15d4e.webp";